import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { TextInput } from '@/components/ui/form/input';
import { XStack } from '@/components/ui/layout/layout';

import { ckDebugStore } from '../ck-debug.store';
import {
  CK_DEBUG_OUTCOME_OPTIONS,
  CK_DEBUG_TRIGGER_OPTIONS,
} from '../ck-debug.utils';

import { CkDebugFilterDropdown } from './ck-debug-filter-dropdown';

export const CkDebugToolbar = observer(() => {
  const filteredCount = ckDebugStore.filteredSnapshots.length;
  const totalCount = ckDebugStore.snapshots.length;
  const { filters } = ckDebugStore;

  return (
    <XStack className="items-center gap-2 px-3 py-2 border-b border-border shrink-0 flex-wrap">
      <CkDebugFilterDropdown
        title="Filter by App"
        selectedValue={filters.app}
        allLabel="All Apps"
        options={ckDebugStore.availableApps.map(({ name, count }) => ({
          value: name,
          label: name,
          count,
        }))}
        onSelect={(app) => ckDebugStore.setFilters({ app })}
      />

      <CkDebugFilterDropdown
        title="Filter by Trigger"
        selectedValue={filters.trigger}
        allLabel="All Triggers"
        options={CK_DEBUG_TRIGGER_OPTIONS.map((trigger) => ({
          value: trigger,
          label: trigger,
        }))}
        onSelect={(trigger) => ckDebugStore.setFilters({ trigger })}
      />

      <CkDebugFilterDropdown
        title="Filter by Outcome"
        selectedValue={filters.outcome}
        allLabel="All Outcomes"
        options={CK_DEBUG_OUTCOME_OPTIONS.map((outcome) => ({
          value: outcome,
          label: outcome,
        }))}
        onSelect={(outcome) => ckDebugStore.setFilters({ outcome })}
      />

      <div className="relative flex-1 min-w-[160px] max-w-[280px]">
        <Icons.search className="absolute left-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-foreground-muted" />
        <TextInput
          placeholder="Search apps, windows..."
          value={filters.searchTerm}
          onChange={(e) =>
            ckDebugStore.setFilters({ searchTerm: e.target.value })
          }
          className="pl-8 h-7 text-xs"
        />
      </div>

      <XStack className="items-center gap-1.5 ml-auto">
        <span className="text-xs text-foreground-muted tabular-nums">
          {filteredCount === totalCount
            ? `${totalCount}`
            : `${filteredCount}/${totalCount}`}
        </span>

        <Button
          variant="ghost"
          size="icon-sm"
          tooltip="Clear all snapshots"
          onClick={() => ckDebugStore.clear()}
        >
          <Icons.trash className="h-3.5 w-3.5" />
        </Button>
      </XStack>
    </XStack>
  );
});
